import { toQuotedString, createAllWorkUrl } from '@atlassian/jira-common-jql/src/helpers.tsx';
import type { VersionId } from '../../common/model/index.tsx';
import systemFields from '../model/system-field.tsx';
import type { Field } from '../model/types.tsx';

export const getIssuesForRelatedFieldUrl = (
	projectKey: string,
	versionId: VersionId,
	field: Field,
): string => {
	const fieldInJql = systemFields.includes(field) ? field.id : toQuotedString(field.name);
	const jql = `project = ${toQuotedString(projectKey)} AND ${fieldInJql} = ${versionId}`;
	return createAllWorkUrl(jql);
};
